export const PAYMENT_MODEL_EMPTY_OPTION = { value: '', label: 'choose payment model' };

export const PAYMENT_MODELS = [
    PAYMENT_MODEL_EMPTY_OPTION,
    { value: 'milestone', label: 'Milestone' },
    { value: 'ongoing', label: 'Ongoing / Support' },
    { value: 'custom', label: 'Custom Schedule' },
    { value: 'one_time', label: 'One-Time' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'annual', label: 'Annual' }
];

export const PAYMENT_MODEL_LABELS = Object.fromEntries(
    PAYMENT_MODELS.filter(m => m.value).map(m => [m.value, m.label])
);

export function paymentModelToFrequency(model) {
    const map = {
        monthly: 'monthly',
        weekly: 'every:1:weeks',
        quarterly: 'quarterly',
        annual: 'yearly',
        one_time: 'oneTime',
        ongoing: 'monthly'
    };
    return map[model] || 'monthly';
}

export function isRecurringPaymentModel(model) {
    return ['monthly', 'weekly', 'quarterly', 'annual'].includes(model);
}
